import { render, staticRenderFns } from "./DepositCollection.vue?vue&type=template&id=b94ee9a4&"
import script from "./DepositCollection.vue?vue&type=script&lang=js&"
export * from "./DepositCollection.vue?vue&type=script&lang=js&"
import style0 from "./DepositCollection.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "DepositCollection.vue"
export default component.exports